import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
  Route,
  Switch,
  useHistory,
  useLocation,
  useRouteMatch,
} from 'react-router-dom';
import * as paths from '../../routes/paths';
import * as actions from './actions';
import selectContentPath from './selectors';
import { RootState } from '../../reducers';
import Modal from '@raydiant/raydial/components/Modal';
import cn from 'classnames';
import ApplicationsPageV2 from '../../pages/ApplicationsPage/ApplicationsPageV2';
import AddContentPageV2 from '../../pages/AddContentPage/AddContentPageV2';

const ContentModalV2 = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const history = useHistory();
  const match = useRouteMatch();

  const contentPath = useSelector(
    (state: RootState) =>
      selectContentPath(state, { location, history, match }).contentPath,
  );

  useEffect(() => {
    if (contentPath) {
      dispatch(actions.contentModalOpened());
    } else {
      dispatch(actions.contentModalClosed());
    }
  }, [contentPath, dispatch]);

  const getLocation = (path: string) => {
    const [pathname, search] = path.split('?');
    return { pathname, search, state: null, hash: '' };
  };

  const isOpen = !!contentPath;
  const modalLocation = contentPath ? getLocation(contentPath) : location;
  const isApplicationsPath =
    modalLocation.pathname === paths.applications.pattern;

  return (
    <Modal
      isOpen={isOpen}
      className={cn('', !isApplicationsPath && 'md:min-w-[1031px]')}
    >
      <Switch location={modalLocation}>
        <Route
          path={paths.applications.pattern}
          render={(routeProps) => (
            <ApplicationsPageV2 {...routeProps} isModal />
          )}
        />
        <Route
          path={paths.presentations.pattern}
          render={(routeProps) => <AddContentPageV2 {...routeProps} isModal />}
        />
      </Switch>
    </Modal>
  );
};

export default ContentModalV2;
